import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import CouponList from './CouponList';
import AddEditCoupon from './AddEditCoupon';
import ViewCouponDetails from './ViewCouponDetails';

const Coupons = () => {
    const menuDispatch = useDispatch();
    const {id} = useParams();
    const path = useLocation().pathname;
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'coupons'
        });
    }, []);
    return (
        <>
            
            {path === "/marketing/coupons" && <CouponList />}
            
            {path.startsWith("/marketing/coupon/") &&
                !path.startsWith("/marketing/coupon/view/") &&
                id && <AddEditCoupon />}

            {path.startsWith("/marketing/coupon/view/") && id > 0 && <ViewCouponDetails />}
        </>
    )
}

export default Coupons;
